<template>
  <div>
    <bio-admin-top-menu></bio-admin-top-menu>
    <div class="clear content">
      <div class="clear-item leftMenu">
        
        <router-link tag="div" 
          :class="{click_active : title1 == item.title}"
          v-for="(item,index) of menu"
          :key="index"
          :to="item.path"
        >
          <span>{{item.title}}</span>
        </router-link>

      </div>
      <div class="tab_content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import bioAdminTopMenu from "../components/bioAdminTopMenu.vue";
export default {
  components: { bioAdminTopMenu },
  data() {
    return {
            serve: this.$store.state.serve,
      //
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      username: "",
      menu: {},
      title1: ""
    };
  },
  created() {
  },
  watch: {
    "$store.state.adminMenu": {
      handler: function(newer, older) {
        this.menu = newer;
        this.$router.push({
          path: newer.path
        });
      },
      deep: true
    },
    "$store.state.leftTitle": {
      handler: function(newer, older) {
        this.title1 = newer;
      },
      deep: true
    }
  },
  methods: {}
};
</script>

<style lang="scss">
.content {
  height: 100%;
  min-width: 1500px;
}
.leftMenu {
  width: 180px !important;
  margin-top: 51px;
  position: absolute;
  background-color: #e2e8f1;
  div {
    width: 180px;
    height: 40px;
    font-size: 14px;
    font-family: "MicrosoftYaHei";
    font-weight: 400;
    border-bottom: 1px solid #dddddd;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
    > span {
      color: rgba(102, 102, 102, 1);
    }
  }
  div:hover {
    width: 180px;
    height: 40px;
    background: rgba(255, 255, 255, 1);
    span {
      color: rgba(52, 152, 219, 1);
    }
  }
  .click_active {
    width: 180px;
    height: 40px;
    background: rgba(255, 255, 255, 1);
    span{
      color: rgba(52, 152, 219, 1);
    }
  }
}
// .clear-item {
// }
// #app {
// }
</style>
